import React, { useEffect, useState } from 'react';
import logo from '../../img/logo.png';
import emoji from '../../img/btn-e.png';
import { GoThreeBars } from "react-icons/go";
import { Link, NavLink } from "react-router-dom";
import { trunc } from "../../utils/helpers";


const menuLinks = [
	{
		id: "0",
		links: "https://launchpad.avnpad.io/",
		name: "home",
	},
	{
		id: "1",
		links: "https://launchpad.avnpad.io/",
		name: "launchpad",
	},
	{
		id: "2",
		links: "https://staking.avnpad.io/",
		name: "staking",
	},
	{
		id: "3",
		links: "https://avnrich.shop/",
		name: "avnrich shop",
	},
	{
		id: "4",
		links: "https://farm.avnrichdefi.com/",
		name: "avnrich farm",
	},
	{
		id: "5",
		links: "https://drive.google.com/file/d/1KupA2kDiR-BZTScZEentx4umJ8XHUnBY/view?usp=drivesdk",
		name: "litepaper",
	},
	{
		id: "6",
		links: "https://bscscan.com/token/0xbf151f63d8d1287db5fc7a3bc104a9c38124cdeb",
		name: "bscscan",
	},
	{
		id: "7",
		links: "https://avnpad.io/info",
		name: "info",
	},
];
const NavBar = ({ onClickConnect, account }) => {
	const [openMenu, setOpenMenu] = useState(false);
	const [headerTop, setHeaderTop] = useState(false);

	const handleMenuToggle = () => {
		setOpenMenu(!openMenu);
	};

	useEffect(() => {
		window.addEventListener("scroll", () => {
			if (window.scrollY > 10) {
				setHeaderTop(true);
			} else {
				setHeaderTop(false);
			}
		});
	}, []);
	return (
		<nav className="navbar navbar-expand-lg topNav">
			<div className="container">
				<Link className="navbar-brand mt-0" to="/">
					<img width="300" src={logo} alt="logo" />
				</Link>
				<button className="navbar-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar" aria-controls="offcanvasNavbar">
					<GoThreeBars />
				</button>
				<div className="offcanvas offcanvas-end" tabindex="-1" id="offcanvasNavbar" aria-labelledby="offcanvasNavbarLabel">
					<div className="offcanvas-header">
						<h5 className="offcanvas-title" id="offcanvasNavbarLabel">
							<img src={logo} alt="logo" />
						</h5>
						<button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
					</div>
					<div className="offcanvas-body d-lg-grid">
						<ul className="navbar-nav justify-content-end flex-grow-1">
							{/* {menuLinks.map(({ id, links, name }) => (
								<li className="nav-item" key={id}>
									<NavLink to={links} className="nav-link">{name}</NavLink>
								</li>
							))} */}

							<li className="nav-item">
							<a target='_blank' rel="noreferrer" href='https://launchpad.avnpad.io/' className="nav-link" id='active'>HOME</a>
							</li>
							<li className="nav-item">
								<a target='_blank' rel="noreferrer" href='https://launchpad.avnpad.io/' className="nav-link" id='active'>LAUNCHPAD</a>
							</li>
							<li className="nav-item">
								<a target="_blank" rel="noreferrer" href='https://staking.avnpad.io/' className="nav-link">STAKING</a>
							</li>
							<li className="nav-item">
								<a target="_blank" rel="noreferrer" href='https://avnrich.shop/' className="nav-link">AVNRICH SHOP</a>
							</li>
							<li className="nav-item">
								<a target="_blank" rel="noreferrer" href='https://farm.avnrichdefi.com/' className="nav-link">AVNRICH FARM</a>
							</li>
							<li className="nav-item">
								<a target="_blank" rel="noreferrer" href='https://drive.google.com/file/d/1KupA2kDiR-BZTScZEentx4umJ8XHUnBY/view?usp=drivesdk' className="nav-link">LITEPAPER</a>
							</li>
							<li className="nav-item">
								<a target="_blank" rel="noreferrer" href='https://bscscan.com/token/0xbf151f63d8d1287db5fc7a3bc104a9c38124cdeb' className="nav-link">BSCSCAN</a>
							</li>
							<li className="nav-item">
								<a target="_blank" rel="noreferrer" href='https://avnpad.io/info' className="nav-link">INFO</a>
							</li>

						</ul>
						<div className="nav-btn d-grid d-lg-flex gap-3 gap-lg-5 ms-auto">
							<a href="https://pancakeswap.finance/swap?inputCurrency=0xbf151f63d8d1287db5fc7a3bc104a9c38124cdeb&outputCurrency=0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c"><img src={emoji} alt="icon" /> BUY AYN</a>
							<button
								onClick={onClickConnect}
								style={{ borderStyle: "none" }}
								className="cmn--btn">
								{account ? trunc(account) : "Connect Wallet"}
							</button>
						</div>
					</div>
				</div>
			</div>
		</nav>
	)
}

export default NavBar